'use strict';

var GoogleModel = require('tscom-google-analytics');

// https://developers.google.com/analytics/devguides/collection/analyticsjs/cookies-user-id#using_localstorage_to_store_the_client_id
module.exports = GoogleModel.extend({
    /**
     * Creates ga object with namespace name from attribute
     */
    createGA: function() {

        var GA_LOCAL_STORAGE_KEY = 'ga:clientId';
        if (window.localStorage) {
            //create GA with namespace
            ga('create', this.ga_id, this.ga_domain, {
                'name': this.get('namespace'),
                'storage': 'none',
                'clientId': localStorage.getItem(GA_LOCAL_STORAGE_KEY)
            });

            ga(function (tracker) {
                localStorage.setItem(GA_LOCAL_STORAGE_KEY, tracker.get('clientId'));
            });
        } else {
            ga('create', this.ga_id, this.ga_domain, {
                'name': this.get('namespace')
            });
        }

        ga(this.get('namespace')+'.send', 'pageview');
    }
});



// WEBPACK FOOTER //
// ./app/scripts/models/google.js